import React, { Component } from 'react';

// CSS.
import './Users.css';

// Services.
import languageService from '../../utils/language/language';

class Users extends Component {
    
    
    render() {
        return (
            <div className=''>
                <div>
                    <img src='../assets/home.svg' className='content-title-img' alt='content'/>
                    <p className='no-margin no-padding content-title-text'><b>{ languageService.strings.users[languageService.getLanguage()] }</b></p>
                </div>
                <br />
                Página en construcción...
            </div>
        );
    }
}

export default Users;